export default __webpack_public_path__ + "static/media/avatar-dummy.b99aa707.jpg";